'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _abyssReact = require('abyss-react');

var _abyssReact2 = _interopRequireDefault(_abyssReact);

var _utils = require('../utils');

var utils = _interopRequireWildcard(_utils);

var _actions = require('../actions');

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IE10_BROWSER = typeof navigator !== 'undefined' && navigator.userAgent.match(/MSIE 10/);

var propTypes = {
  children: _propTypes2.default.node,
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  label: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  defaultValue: _propTypes2.default.bool,
  defaultSet: _propTypes2.default.bool,
  model: _propTypes2.default.string,
  validators: _propTypes2.default.object,
  field: _propTypes2.default.object.isRequired,
  modelValue: _propTypes2.default.bool,
  value: _propTypes2.default.bool,
  localValue: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  inputRef: _propTypes2.default.object,
  setInputRef: _propTypes2.default.func,
  validateModel: _propTypes2.default.func,
  handleChange: _propTypes2.default.func,
  handleFocus: _propTypes2.default.func,
  handleBlur: _propTypes2.default.func,
  handleKeyDown: _propTypes2.default.func
};

var connectState = function connectState(state, _ref) {
  var model = _ref.model;
  return {
    field: utils.getField(state, model),
    modelValue: utils.getModelValue(state, model) || false
  };
};

var defaultState = function defaultState(props) {
  return {
    localValue: !!props.defaultValue,
    defaultSet: false,
    focused: false
  };
};

var methods = {
  setInputRef: function setInputRef(_ref2, ref) {
    var setRef = _ref2.setRef;

    setRef({ inputRef: ref });
  },
  componentDidMount: function componentDidMount(_ref3) {
    var validateModel = _ref3.validateModel,
        model = _ref3.model;

    if (model) {
      validateModel();
    }
  },
  componentWillUnmount: function componentWillUnmount(_ref4) {
    var dispatch = _ref4.dispatch,
        model = _ref4.model;

    if (model) {
      setTimeout(function () {
        return dispatch(actions.unset(model));
      });
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(props, nextProps) {
    return utils.propsChanged(props, nextProps, ['value', 'localValue', 'modelValue', 'defaultValue', 'field', 'disabled', 'focused']);
  },
  componentDidUpdate: function componentDidUpdate(_ref5, prevProps) {
    var field = _ref5.field,
        inputRef = _ref5.inputRef,
        validateModel = _ref5.validateModel,
        defaultSet = _ref5.defaultSet,
        defaultValue = _ref5.defaultValue,
        dispatch = _ref5.dispatch,
        model = _ref5.model,
        value = _ref5.value,
        localValue = _ref5.localValue,
        modelValue = _ref5.modelValue,
        validators = _ref5.validators,
        setState = _ref5.setState;

    if (model) {
      if (!prevProps.focused && field.focused) {
        inputRef.focus();
      }

      if (validators && field.validated === false) {
        validateModel();
      }

      if (!defaultSet) {
        var defaultVal = modelValue || defaultValue;

        if (defaultVal) {
          setState({
            localValue: defaultVal,
            defaultSet: true
          });

          if (modelValue !== defaultVal) {
            dispatch(actions.set(model, defaultVal, {
              errors: utils.getErrors(defaultVal, validators)
            }));
          }
        }
      } else if (localValue !== modelValue) {
        setState({ localValue: modelValue });
      }
    }
  },
  validateModel: function validateModel(_ref6) {
    var setState = _ref6.setState,
        dispatch = _ref6.dispatch,
        model = _ref6.model,
        modelValue = _ref6.modelValue,
        validators = _ref6.validators;

    setState({ localValue: modelValue });
    dispatch(actions.validate(model, modelValue, {
      errors: utils.getErrors(modelValue, validators)
    }));
  },
  handleChange: function handleChange(_ref7, e) {
    var onChange = _ref7.onChange,
        dispatch = _ref7.dispatch,
        model = _ref7.model,
        modelValue = _ref7.modelValue,
        setState = _ref7.setState,
        validators = _ref7.validators;

    if (model) {
      var value = e.target.checked;
      setState({ localValue: value });

      if (value !== modelValue) {
        dispatch(actions.set(model, value, {
          errors: utils.getErrors(value, validators),
          touched: true
        }));
      }
    }

    if (onChange) {
      onChange(e);
    }
  },
  handleFocus: function handleFocus(_ref8, e) {
    var onFocus = _ref8.onFocus,
        setState = _ref8.setState;

    setState({ focused: true });

    if (onFocus) {
      onFocus(e);
    }
  },
  handleBlur: function handleBlur(_ref9, e) {
    var onBlur = _ref9.onBlur,
        dispatch = _ref9.dispatch,
        model = _ref9.model,
        field = _ref9.field,
        setState = _ref9.setState;

    if (model) {
      if (field.focused || !field.touched) {
        setTimeout(function () {
          if (!window.__ABYSS_FORM_RESET__) {
            dispatch(actions.update(model, {
              focused: false,
              touched: true
            }));
          }
        });
      }
    }

    setState({ focused: false });

    if (onBlur) {
      onBlur(e);
    }
  },
  handleKeyDown: function handleKeyDown(_ref10, e) {
    var onKeyDown = _ref10.onKeyDown,
        onChange = _ref10.onChange,
        dispatch = _ref10.dispatch,
        model = _ref10.model,
        modelValue = _ref10.modelValue,
        setState = _ref10.setState,
        validators = _ref10.validators;

    if (e.key === 'Enter' || e.keyCode === 32) {
      e.preventDefault();
      e.stopPropagation();
      e.target.checked = !e.target.checked;

      if (model) {
        var value = e.target.checked;
        setState({ localValue: value });

        if (value !== modelValue) {
          dispatch(actions.set(model, value, {
            errors: utils.getErrors(value, validators),
            touched: true
          }));
        }
      }

      if (onChange) {
        onChange(e);
      }
    }

    if (onKeyDown) {
      onKeyDown(e);
    }
  }
};

var Checkbox = function Checkbox(_ref11) {
  var children = _ref11.children,
      id = _ref11.id,
      className = _ref11.className,
      model = _ref11.model,
      style = _ref11.style,
      label = _ref11.label,
      value = _ref11.value,
      localValue = _ref11.localValue,
      focused = _ref11.focused,
      disabled = _ref11.disabled,
      field = _ref11.field,
      setInputRef = _ref11.setInputRef,
      handleChange = _ref11.handleChange,
      handleFocus = _ref11.handleFocus,
      handleBlur = _ref11.handleBlur,
      handleKeyDown = _ref11.handleKeyDown,
      props = _objectWithoutProperties(_ref11, ['children', 'id', 'className', 'model', 'style', 'label', 'value', 'localValue', 'focused', 'disabled', 'field', 'setInputRef', 'handleChange', 'handleFocus', 'handleBlur', 'handleKeyDown']);

  delete props.defaultValue;
  delete props.defaultSet;
  delete props.modelValue;
  delete props.validators;
  delete props.inputRef;
  delete props.validateModel;

  var fieldClasses = ['abyss-checkbox', className];

  if (IE10_BROWSER) {
    fieldClasses.push('abyss-checkbox--IE10');
  }

  if (field.touched && field.changed) {
    if (field.valid) {
      fieldClasses.push('abyss-form--valid');
    } else {
      fieldClasses.push('abyss-form--invalid');
    }
  }

  var fieldClassName = fieldClasses.filter(function (c) {
    return c;
  }).join(' ');

  var checked = model ? localValue : value;

  return _react2.default.createElement(
    'div',
    {
      className: fieldClassName,
      style: style,
      setClasses: {
        'abyss-checkbox--active': checked,
        'abyss-checkbox--disabled': disabled,
        'abyss-form--focused': focused
      },
      role: 'checkbox',
      'aria-checked': checked ? 'true' : 'false' },
    _react2.default.createElement(
      'label',
      { classes: 'abyss-checkbox__label', htmlFor: id },
      _react2.default.createElement(
        'span',
        { classes: 'abyss-checkbox__wrapper' },
        _react2.default.createElement('input', _extends({}, props, {
          id: id,
          ref: setInputRef,
          classes: 'abyss-checkbox__input',
          type: 'checkbox',
          checked: checked,
          onChange: handleChange,
          onFocus: handleFocus,
          onBlur: handleBlur,
          onKeyDown: handleKeyDown,
          disabled: disabled })),
        _react2.default.createElement('span', { classes: 'abyss-checkbox__icon' })
      ),
      _react2.default.createElement(
        'span',
        null,
        label || children
      )
    )
  );
};

Checkbox.propTypes = propTypes;
Checkbox.connectState = connectState;
Checkbox.defaultState = defaultState;
Checkbox.methods = methods;

exports.default = (0, _abyssReact2.default)(Checkbox);


//////////////////
// WEBPACK FOOTER
// ./node_modules/abyss-form/lib/Checkbox/Checkbox.js
// module id = 560
// module chunks = 0